import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { InstantSearchDisplayType } from '~/core/configuration/configuration-global-config.type';
import { useCategoryResults } from '~/hooks/useCategoryResults';
import { useFullTextResults } from '~/hooks/useFulltextResults';
import { InstantCategories } from './categories/InstantCategories';
import { InstantFullText } from './fulltext/InstantFulltext';
import sidebarStyles from './instantSearchSidebar.module.scss';

interface InstantSearchSidebarProps {
    enableSidebar?: boolean;
    displayType?: InstantSearchDisplayType;
}

const InstantSearchSidebar: React.FC<InstantSearchSidebarProps> = ({ enableSidebar, displayType }) => {
    const { categoryResults } = useCategoryResults();
    const [showSidebar, setShowSidebar] = useState(enableSidebar);
    const { fullTextResults } = useFullTextResults();

    useEffect(() => {
        if (
            (categoryResults?.every((category) => category.result.hits.length === 0) || !categoryResults) &&
            fullTextResults?.length === 0
        ) {
            setShowSidebar(false);
        } else {
            setShowSidebar(enableSidebar);
        }
    }, [categoryResults, fullTextResults, enableSidebar]);

    if (!showSidebar) {
        return null;
    }

    return (
        <div
            className={classNames(
                sidebarStyles.instantSearchSidebar,
                displayType === 'rows' ? sidebarStyles.inRowsView : sidebarStyles.inGridView
            )}
            data-testid="instantsearch-sidebar"
        >
            <InstantCategories />
            <InstantFullText />
        </div>
    );
};

export default InstantSearchSidebar;
